import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CoreModule } from '@core/core.module';
import { HtmlTemplatingService } from './html-templating.service';
import { AmortizationTableComponent } from './components/amortization-table/amortization-table.component';

@NgModule({
	declarations: [AmortizationTableComponent],
	imports: [CommonModule, CoreModule],
	providers: [HtmlTemplatingService],
})
export class HtmlTemplatingModule {
	constructor(svc: HtmlTemplatingService) {
		svc.init();
	}
}
